import React from 'react';
import ReactPlayer from 'react-player';
import './AdModal.scss';
import {getAdVideoUrl} from '../api/iposApi';

const AdModal = ({closeModal, onClose, onOk, branchInfo, t}) => {

  const onContentClick = () => {
    onClose();
    closeModal();
  };

  const adVideoUrlArray = branchInfo.VideoPaths.map(ad => getAdVideoUrl(branchInfo.branch_guid_code, ad.path_txt));

  return (
    <div className="ad-modal-content" onClick={ onContentClick }>
      <ReactPlayer
        playing
        loop
        volume={ 0 }
        muted
        width="100%"
        height="100%"
        playsInline
        url={ adVideoUrlArray }
        onError={ (error) => {
          alert(error);
        } }
      />

      <div className={ 'close-description' }>
        {t('ad_modal.close_description')}
      </div>
    </div>
  );
};

export default AdModal;
